export function buildWorkflowAssistantImportMessage(content: string, fileName: string): string {
  return [
    'Analyze these external workflow instructions and create or update the workflow draft in this builder.',
    `Source file: ${fileName}`,
    '',
    content.trim(),
  ].join('\n');
}
